import CashDesks from './CashDesks.redux';

export default CashDesks;
